import DefaultSearchList from './DefaultSearchList';

export default DefaultSearchList;
